/**
 * Daily Devotional Sundae endpoints — wraps `/api/games/sundae/*`.
 * Cookie-auth via `withCredentials: true` (matches the rest of Lumera).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

export const fetchSundaeToday = () =>
  axios.get(`${BACKEND_URL}/api/games/sundae/today`, cfg).then((r) => r.data);

export const startSundae = () =>
  axios.post(`${BACKEND_URL}/api/games/sundae/start`, {}, cfg).then((r) => r.data);

export const completeSundae = (totalElapsedMs) =>
  axios
    .post(
      `${BACKEND_URL}/api/games/sundae/complete`,
      { total_elapsed_ms: Math.max(0, Math.round(totalElapsedMs)) },
      cfg,
    )
    .then((r) => r.data);

export const fetchSundaeLeaderboard = (date, limit = 20) =>
  axios
    .get(`${BACKEND_URL}/api/games/sundae/leaderboard`, {
      ...cfg,
      params: { date, limit },
    })
    .then((r) => r.data);

export const fetchSundaeStreak = () =>
  axios.get(`${BACKEND_URL}/api/games/sundae/streak`, cfg).then((r) => r.data);

export const fetchSundaeGroupWeek = (userIds, endDate) =>
  axios
    .get(`${BACKEND_URL}/api/games/sundae/group-week`, {
      ...cfg,
      params: {
        user_ids: Array.isArray(userIds) ? userIds.join(',') : userIds,
        ...(endDate ? { end_date: endDate } : {}),
      },
    })
    .then((r) => r.data);

export const SUNDAE_GAME_LABELS = {
  trivia: { en: 'Bible Trivia', es: 'Trivia Bíblica' },
  scramble: { en: 'Verse Scramble', es: 'Reordenar Versículo' },
  whosaidit: { en: 'Who Said It?', es: '¿Quién lo dijo?' },
  match: { en: 'Verse Match', es: 'Empareja Versículos' },
  crossword: { en: 'Bible Crossword', es: 'Crucigrama Bíblico' },
};
